export default "__VITE_PUBLIC_ASSET__6313216e__"